import Button from "../Buttons/Button";
import { buttonWithAuthorization } from "../buttonWithAuthorization";

const FormSubmitButton = props => {
  const { onClick, submitLabel, disabled, isSubmitting } = props;
  const isDisabled = disabled || isSubmitting;

  return (
    <Button
      type="button"
      // The order-1 class is used to ensure the submit button is always after the cancel
      // button on mobile which is the expected order for users.
      className="btn btn-primary btn-block-md modal-action box-shadow order-1"
      onClick={onClick}
      label={submitLabel}
      iconClassName="icon-validate"
      iconPosition="after"
      data-loading={isSubmitting}
      disabled={isDisabled}
      data-contribution-form-validate-button
    />
  );
};

export default buttonWithAuthorization(FormSubmitButton);
